import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import camelcaseKeys from 'camelcase-keys-all-env';

import {
    fetchCCFEntries as fetchCCFEntriesAction,
    getCCFEntriesTabs,
} from '@client/redux/modules/ccfEntries';
import { RestClient } from '@pegasus/rest-client';

import { Tab } from '@shared/types/mylounge/ccfEntries';

let crossCampaignEntriesAbortController: AbortController | null;

async function fetchCrossCampaignEntries(): Promise<{ tabs: Tab[] }> {
    if (crossCampaignEntriesAbortController) {
        crossCampaignEntriesAbortController.abort();
    }
    crossCampaignEntriesAbortController = new AbortController();
    try {
        const response = await RestClient.get('/api/phoenix/catalog/ccf-entries')
            .withClientType('web')
            .acceptStatusCodes([200])
            .withAbortController(crossCampaignEntriesAbortController)
            .send();
        const parsedResponse = await response.json();
        return camelcaseKeys(parsedResponse, { deep: true });
    } finally {
        crossCampaignEntriesAbortController = null;
    }
}

export const useCCFEntries = () => {
    const ccfEntriesTabs = useSelector(getCCFEntriesTabs);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchCCFEntries = async () => {
            try {
                if (!ccfEntriesTabs?.length) {
                    const { tabs } = await fetchCrossCampaignEntries();
                    dispatch(fetchCCFEntriesAction.done({ result: { tabs } }));
                }
            } catch (e) {
                console.log(e);
            }
        };
        fetchCCFEntries();
    }, []);

    return ccfEntriesTabs;
};
